import featureFlags from "../../config/featureFlags";

interface DetailItem {
  id: number;
  category: "experience" | "education";
  icon: string;
  year: string;
  title: string;
  desc: string;
  details: string[];
  href?: string;
}

type DetailItemData = Omit<DetailItem, "id">;

const items: DetailItemData[] = [
    {
    category: "experience",
    icon: "icon-briefcase",
    year: "2026 - Present",
    title:
      "Gap",
    desc: "Software Engineer",
    details: [
    ],
  },
  {
    category: "experience",
    icon: "icon-briefcase",
    year: "2024 - 2025",
    title:
      "<a href='https://www.kscale.dev/' target='_blank'>K-Scale Labs (YC W24)</a>",
    desc: "Software Engineer",
    details: [
      "Built full-stack features for K-Scale open-source platform."
    ],
  },
  {
    category: "experience",
    icon: "icon-briefcase",
    year: "2023 - 2024",
    title: "<a href='https://www.galvanize.com/' target='_blank'>Galvanize</a>",
    desc: "Software Engineering Resident",
    details: [
      "Developed and improved a Django-based educational platform, delivering new features, optimizing internal tools, and increasing API efficiency. Mentored 50+ developers across Django, React, FastAPI, and Docker through technical coaching, debugging support, code reviews, and workshops on engineering best practices."
    ],
  },
  {
    category: "experience",
    icon: "icon-briefcase",
    year: "2021 - 2022",
    title: "<a href='https://ridezum.com/' target='_blank'>Zūm</a>",
    desc: "Operations",
    details: [
      "Built Python automation tools, scripted dashboards, and data pipelines to streamline trip management, scheduling, reporting, and vendor-performance analysis. Eliminated repetitive workflows, saved the team 10+ hours per week, and generated insights that supported negotiations and improved booking success rates."
    ],
  },
  {
    category: "experience",
    icon: "icon-briefcase",
    year: "2019 - 2021 ",
    title: "<a href='https://getcruise.com/' target='_blank'>Cruise</a>",
    desc: "Product Engineer",
    details: [
      "Building autonomous-vehicle systems and supporting infrastructure, with a focus on product development, testing, and data-driven improvements."
    ],
  },
  {
    category: "education",
    icon: "icon-graduation",
    year: "2024",
    title: `<a href="${process.env.PUBLIC_URL}/assets/jpmc_certificate.pdf" target="_blank">JPMorgan Chase & Co.</a>`,
    desc: "Software Engineering Job Simulation",
    details: [
      "Completed practical software engineering tasks in a simulated work environment.",
      "Developed financial data visualization tools using Python and React.",
      "Implemented data processing algorithms for financial analysis.",
    ],
  },
  ...(featureFlags.bootcamp_mode
    ? [
      {
        category: "education",
        icon: "icon-graduation",
        year: "2023",
        title: `<a href="${process.env.PUBLIC_URL}/assets/hackreactor_certificate.pdf" target="_blank">Hack Reactor</a>`,
        desc: "Advanced Software Engineering Immersive",
        details: [
          "Completed 1000+ hours of intensive software engineering training.",
          "Mastered software engineering fundamentals and best practices.",
        ],
      },
    ] as DetailItemData[]
    : []),
  {
    category: "education",
    icon: "icon-graduation",
    year: "2021",
    title: `<a href='https://www.parchment.com/u/award/0d01d1b9762bd51a10eff9f7b24eb429' target='_blank'>San Francisco State University</a>`,
    desc: "Bachelor's of Science",
    details: [],
  },
];

const Data: DetailItem[] = items.map((item, index) => ({
  ...item,
  id: index + 1,
}));

export default Data;
